import React from 'react';

const BlackButton = ({ name, onClick, icon, type = "submit", id="" }) => {
    return (
        <button type={type} id={id} className="w-full text-white bg-[#1A202C] py-[12px] px-[32px]  rounded-[3px] cursor-pointer flex justify-center items-center mb-3 
        leading-6 disabled:bg-opacity-75" onClick={onClick}><span className="mr-2.5">{icon}</span>{name}</button>
    );
};

export default BlackButton;